import { NotificationContext, NotificationContextType } from "@/context/NotificationContext";
import { useContext } from "react";

export function useNotification(): NotificationContextType {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error("useNotification deve ser utilizado dentro de um NotificationProvider");
  }
  return context;
}
